// A plan as the catalog endpoint returns it. The figures themselves live in the generalDB and
// are served by GET /base/public/plans, because every one of them is expected to move: the
// source document already took Ultimate from $999 to $2,300 and back, the overage rates are
// still being negotiated, and a screen for editing a plan's allowances is planned.

export const ANNUAL_DISCOUNT_PERCENT = 10

export interface PlanFeature {
    text?: string
    warn?: boolean
}

export interface Plan {
    id?: string
    /** Stable key: free, pro, proplus, ultimate, enterprise. */
    code?: string
    name?: string
    /** Small label above the name: who the plan is for. */
    eyebrow?: string
    tagline?: string
    /** Wording on the plan's button. */
    actionText?: string

    monthlyPrice: number
    annualPrice: number
    /** Enterprise: quoted per customer, so there is no figure to show. */
    isCustomPriced?: boolean
    priceText?: string

    includedUsers: number
    includedMessages: number
    includedMinutes: number
    includedNumbers: number

    overageMessageRate: number
    overageMinuteRate: number
    extraUserPrice: number
    extraNumberPrice: number

    /** Carries the "Best value" ribbon. */
    highlighted?: boolean
    /** Drawn on a dark card. */
    darkCard?: boolean
    /** False for Enterprise: it cannot be bought from a page. */
    selfService?: boolean
    /** False for Free: there is nothing to pay, so no card is collected. */
    requiresPayment?: boolean

    features: PlanFeature[]
}
